"use client";

import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import type { ReactNode } from "react";

const BRAND_COLOR = "#68c1e0";
type ChatDockLauncherProps = {
  label: string;
  icon: ReactNode;
  badgeCount?: number;
  onClick: () => void;
  hidden?: boolean;
  backgroundColor?: string;
  textColor?: string;
  borderColor?: string;
  iconBackgroundColor?: string;
};

const ChatDockLauncher = ({
  label,
  icon,
  badgeCount,
  onClick,
  hidden,
  backgroundColor = BRAND_COLOR,
  textColor = "#ffffff",
  borderColor = "rgba(255,255,255,0.6)",
  iconBackgroundColor = "rgba(255,255,255,0.2)",
}: ChatDockLauncherProps) => {
  const isLightText = textColor.toLowerCase() === "#ffffff";
  const badgeStyles = {
    backgroundColor: isLightText ? "#ffffff" : backgroundColor,
    color: isLightText ? "#3b7a93" : "#ffffff",
  };

  return (
    <Button
      size="lg"
      onClick={onClick}
      style={{ backgroundColor, color: textColor, borderColor }}
      className={cn(
        "rounded-full shadow-xl hover:shadow-2xl transition-all duration-300",
        "border h-14 px-6 font-semibold flex items-center justify-between gap-4",
        "hover:brightness-95 focus-visible:ring-offset-0",
        hidden && "hidden"
      )}
    >
      <span className="flex items-center gap-3">
        <span
          className="grid h-9 w-9 place-items-center rounded-full"
          style={{ backgroundColor: iconBackgroundColor }}
        >
          {icon}
        </span>
        <span>{label}</span>
      </span>
      {badgeCount && badgeCount > 0 && (
        <Badge
          className="text-xs font-bold px-2 py-0"
          style={badgeStyles}
        >
          {badgeCount > 99 ? "99+" : badgeCount}
        </Badge>
      )}
    </Button>
  );
};

export default ChatDockLauncher;

